export default function pagingMap(pagination) {
    // Check if pagination is array
    if (Array.isArray(pagination)) {
        // If it is, we take the first element
        // This is useful when the API returns an array of pagination objects
        pagination = pagination[0]
    }

    return {
        perPage: +pagination.perPage,
        prevPage: +pagination.prevPage,
        nextPage: +pagination.nextPage,
        page: +pagination.page,
        totalPages: +pagination.totalPages,
        totalRecords: +pagination.totalRecords
    }
}
